import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWordOfWisdom from "../../../../src/content/bgwordsofwisdom/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWordOfWisdom,
  React
};